function initAccordion(accordion) {
  const id = accordion.id
  const trigger = accordion.querySelector('.js-c-ui-accordion-trigger')
  const panel = accordion.querySelector('.js-c-ui-accordion-panel')
  const icon = accordion.querySelector('.js-c-ui-accordion-icon')

  if (!trigger || !panel || !icon || !id) return
  // eslint-disable-next-line no-undef
  let isOpen = sessionStorage.getItem(id) === 'true'

  panel.classList.add('tw-overflow-hidden', 'tw-transition-[height]', 'tw-duration-300', 'tw-ease-in-out')

  if (isOpen) {
    panel.classList.remove('tw-hidden')
    panel.style.height = panel.scrollHeight + 'px'
    trigger.setAttribute('aria-expanded', 'true')
    icon.classList.add('tw-rotate-180')

    panel.addEventListener('transitionend', () => {
      if (isOpen) {
        panel.style.height = 'auto'  // allow dynamic height after open transition
      }
    }, { once: true })

  } else {
    panel.style.height = '0px'
    trigger.setAttribute('aria-expanded', 'false')
  }

  function openPanel() {
    panel.classList.remove('tw-hidden')
    panel.style.height = panel.scrollHeight + 'px'
    trigger.setAttribute('aria-expanded', 'true')
    isOpen = true
    // eslint-disable-next-line no-undef
    sessionStorage.setItem(id, 'true')
    icon.classList.add('tw-rotate-180')

    panel.addEventListener('transitionend', () => {
      if (isOpen) {
        panel.style.height = 'auto'
      }
    }, { once: true })
  }

  function closePanel() {
    panel.style.height = panel.scrollHeight + 'px'
    // eslint-disable-next-line no-undef
    requestAnimationFrame(() => {
      panel.style.height = '0px'
    })

    trigger.setAttribute('aria-expanded', 'false')
    isOpen = false
    // eslint-disable-next-line no-undef
    sessionStorage.setItem(id, 'false')
    icon.classList.remove('tw-rotate-180')
  }

  function toggleAccordion() {
    if (isOpen) {
      closePanel()
    } else {
      openPanel()
    }
  }

  function handleKeydown(event) {
    if (event.key === ' ' || event.key === 'Enter') {
      event.preventDefault()
      toggleAccordion()
    }
  }

  trigger.addEventListener('click', toggleAccordion)
  trigger.addEventListener('keydown', handleKeydown)
}

function initializeAccordions() {
  const accordions = document.querySelectorAll('.js-c-ui-accordion')
  accordions.forEach(initAccordion)
}

initializeAccordions()
